/**
 * The skill's source, read-only — the old web's `codeContent` (ToolEditor):
 * CodeMirror with the C++ grammar (the closest bundled grammar to C#, and the
 * one the old web used) under the `vscodeDark` theme, filling its column.
 *
 * Read-only on purpose: the code changes through the edit chat and
 * `commit_skill_version`, never by typing here — same as the old editor.
 */
import CodeMirror from "@uiw/react-codemirror";
import { cpp } from "@codemirror/lang-cpp";
import { vscodeDark } from "@uiw/codemirror-theme-vscode";
import { useLocale } from "../../i18n/LocaleProvider";
import { LoaderIcon } from "./icons";

const EXTENSIONS = [cpp()];

export function CodeView({ code, loading = false }: { code: string; loading?: boolean }) {
  const { t } = useLocale();
  return (
    <div className="skill-code-editor">
      <CodeMirror value={code} height="100%" extensions={EXTENSIONS} theme={vscodeDark} readOnly={true} className="skill-code-cm" />
      {/**
       * **An overlay while another version's code is being fetched** (owner).
       *
       * Switching versions replaced the whole CodeMirror document the moment it arrived, and
       * a full-document swap in a dark editor reads as a blink — the more so because the
       * banner above had already changed to the new version, so the flash was the only sign
       * anything had happened.
       *
       * Over the code rather than in place of it: the outgoing version stays visible
       * underneath, so the panel keeps its size and its scroll, and the change reads as one
       * deliberate load instead of two repaints.
       */}
      {loading ? (
        <div className="skill-code-loading" role="status">
          <LoaderIcon size={18} />
          <span>{t("common.loading")}</span>
        </div>
      ) : null}
    </div>
  );
}
